export { TestimonialSlider } from './TestimonialSlider';
